import { Grid } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { useLoggedInUser } from '../../../app/hooks/useLoggedInUser'
import { useGetBrandsQuery } from '../../../app/redux-fetch/apiAssets'
import DefaultSpacingGrid from '../../../components/Containers/DefaultSpacingGrid'
import FormDatePickerInput from '../../../components/Forms/FormDatePickerInput'
import FormInput from '../../../components/Forms/FormInput'
import FormSelect from '../../../components/Forms/FormSelect'
import { messages } from '../messages'
import { getMinDate } from '../utils/utils'

export function AssetDetailGroup({ disabled }: { disabled?: boolean }) {
  const { formatMessage } = useIntl()
  const { tenantId } = useLoggedInUser()
  const { data: brands = [] } = useGetBrandsQuery({ tenantId })
  const { watch } = useFormContext()
  const registrationDate = watch('detail.registrationDate')
  const registrationExpiryMinDate = getMinDate(registrationDate)
  const registrationDateMaxDate = new Date()

  const brandOptions = brands
    .map((b: any) => ({ label: b.name, value: b.id }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return (
    <DefaultSpacingGrid container spacing={2}>
      <Grid item xs={12} md={6}>
        <FormSelect
          name='detail.brandId'
          label={formatMessage(messages.assetsDetailsBrand)}
          options={brandOptions}
          disabled={disabled || brandOptions.length === 0}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          name='detail.model'
          label={formatMessage(messages.assetsDetailsModel)}
          disabled={disabled}
          maxLength={100}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.productionYear'
          label={formatMessage(messages.assetsDetailsProductionYear)}
          minDate={new Date('1900-01-01')}
          maxDate={registrationDateMaxDate}
          disabled={disabled}
          format='YYYY'
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          name='detail.registrationNumber'
          label={formatMessage(messages.assetsDetailsRegistrationNumber)}
          disabled={disabled}
          maxLength={20}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.registrationDate'
          label={formatMessage(messages.assetsDetailsRegistrationDate)}
          minDate={new Date('1900-01-01')}
          maxDate={registrationDateMaxDate}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.registrationExpiry'
          label={formatMessage(messages.assetsDetailsRegistrationExpiry)}
          minDate={registrationExpiryMinDate}
          disabled={disabled || !registrationDate}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.insuranceExpiry'
          label={formatMessage(messages.assetsDetailsInsuranceExpiry)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.operationCardExpiry'
          label={formatMessage(messages.assetsDetailsOperationCardExpiry)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          name='detail.numberOfDoors'
          label={formatMessage(messages.assetsDetailsNumberOfDoors)}
          type='number'
          disabled={disabled}
          maxValue={255}
          numberFormatProps={{
            allowOnlyIntegers: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormInput
          name='detail.chassisNumber'
          label={formatMessage(messages.assetsDetailsChassisNumber)}
          disabled={disabled}
          maxLength={100}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.mvpiExpiry'
          label={formatMessage(messages.assetsDetailsMvpiExpiry)}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDatePickerInput
          name='detail.maintenanceEndDate'
          label={formatMessage(messages.assetsDetailsMaintenanceEndDate)}
          disabled={disabled}
        />
      </Grid>
    </DefaultSpacingGrid>
  )
}
